import { gql } from "@apollo/client"

export const ENABLE_STOCK = gql`
  mutation($storeId: String!, $isStockEnabled: Boolean!) {
    updateSettings(restaurantId: $storeId, isStockEnabled: $isStockEnabled) {
       isStockEnabled
    }
  }
`
